import React, { useEffect, useState, useRef } from "react";
import styles from "../styles/order_book.module.css";
import Layout from "../components/Layout/Layout";
import { API_Path, socketUrl } from "../const";
import { GetApi } from "../api/api-service";
import io from "socket.io-client";
import emptyRecordImg from "../assets/images/empty_record.svg";
import { parseFloatAmt } from "../components/common/CommonFun";
import Loader from "../components/loader/Loader";
import usePageTitle from "../components/customHook/usePageTitle";
import SelectField from "../components/select_option/SelectField";
import { useLocation, useNavigate } from "react-router-dom";

export default function FullOrderBook() {
    const location = useLocation();
    usePageTitle("Full Order Book");
    const navigate = useNavigate();
    const [pairs, setPairs] = useState([]);
    const [firstCoins, setFirstCoins] = useState([]);
    const [selectedFirstCoin, setSelectedFirstCoin] = useState("BTC");
    const [lastCoins, setLastCoins] = useState([]);
    const [selectedLastCoin, setSelectedLastCoin] = useState("USDT");
    const [buySpread, setBuySpread] = useState(0);
    const [sellSpread, setSellSpread] = useState(0);
    const [priceDecimal, setPriceDecimal] = useState(0);
    const [volumeDecimal, setVolumeDecimal] = useState(0);
    const [bookSell, setBookSell] = useState([]);
    const [bookBuy, setBookBuy] = useState([]);
    const [showLoaderBookSell, setShowLoaderBookSell] = useState(true);
    const [showLoaderBookBuy, setShowLoaderBookBuy] = useState(true);
    const socket = useRef(null);
    const initializedRef = useRef(false);

    useEffect(() => {
        if (!initializedRef.current) {
            initializedRef.current = true;
            getMarketMainCoin();
        }
    }, []);

    useEffect(() => {
        if (location.pathname === "/orderbook") {
            if (!socket.current) {
                socket.current = io.connect(socketUrl);
            }
            const pairName = selectedFirstCoin + selectedLastCoin;
            const pairObj = pairs.find((x) => x.PAIRNAME === pairName);
            if (pairObj) {
                setBuySpread(pairObj.SPREAD_BUY);
                setSellSpread(pairObj.SPREAD_SELL);
                setPriceDecimal(pairObj.PRICE_PRECISION);
                setVolumeDecimal(pairObj.VOLUME_PRECISION);
            }
            socketConnect(true);
            if (pairs && pairs.length > 0) sendSocketService();
            return () => {
                socketConnect(false);
                socket.current.off("ReceiveOrderBook");
            };
        }
    }, [location.pathname, selectedFirstCoin, selectedLastCoin, pairs]);

    const getMarketMainCoin = async () => {
        try {
            const response = await GetApi(API_Path.GetMarketMainCoin);
            if (response.data.length > 0) {
                setPairs(response.data);
                const firstCoins = [...new Set(response.data.map((item) => item.FIRST))];
                if (firstCoins.length > 0) {
                    setFirstCoins(firstCoins);
                    const activePair = response.data.find((x) => x.v_active === "1");
                    setSelectedFirstCoin(activePair?.FIRST || firstCoins[0]);
                }
                const lastCoins = [...new Set(response.data.map((item) => item.LAST))];
                if (lastCoins.length > 0) {
                    setLastCoins(lastCoins);
                    setSelectedLastCoin(lastCoins[0]);
                }
                const pairname = localStorage.getItem("RunningPair");
                if (pairname) {
                    const selectedData = response.data.find((pair) => pair.PAIRNAME.toLowerCase() === pairname.toLowerCase());
                    setSelectedFirstCoin(selectedData.FIRST);
                    setSelectedLastCoin(selectedData.LAST);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const socketConnect = (connect) => {
        if (connect) {
            if (!socket.current.connected) {
                socket.current.connect();
                setTimeout(() => {
                    if (!socket.current.connected) {
                        console.log("Error connecting to socket");
                    }
                }, 5000);
            }
        } else {
            if (socket.current.connected) {
                socket.current.disconnect();
            }
        }
    };

    const sendSocketService = () => {
        socketReceiveMarkets();
        // setTimeout(() => {
        socketSendMarkets();
        // }, 200);
    };
    const [totalSellVolume, setTotalSellVolume] = useState(0);
    const [totalBuyVolume, setTotalBuyVolume] = useState(0);

    const socketReceiveMarkets = () => {
        socket.current.on("ReceiveOrderBook", (data) => {
            try {
                if (data.aggAsks) {
                    {
                        console.log(data.aggAsks, "data.aggAsks");
                    }
                    const totalVolume = data.aggAsks.reduce((sum, item) => {
                        return sum + parseFloat(item.volume); // Convert volume to float and add to the sum
                    }, 0);
                    setTotalSellVolume(totalVolume);
                    setBookSell([...data.aggAsks].reverse());
                } else {
                    setBookSell([]);
                }
                if (data.aggBids) {
                    const totalVolume = data.aggBids.reduce((sum, item) => {
                        return sum + parseFloat(item.volume); // Convert volume to float and add to the sum
                    }, 0);
                    setTotalBuyVolume(totalVolume);
                    setBookBuy(data.aggBids);
                }else {
                    setBookBuy([]);
                }
                setShowLoaderBookSell(false);
                setShowLoaderBookBuy(false);
            } catch (ex) {
                console.log("Error processing data:", ex);
            }
        });
    };

    const socketSendMarkets = () => {
        const pairObj = pairs.find((x) => x.PAIRNAME === selectedFirstCoin + selectedLastCoin);
        if (pairObj) {
            socket.current.emit("SendOrderBook", {
                PAIR: selectedFirstCoin + selectedLastCoin,
                COUNT: 5000,
                BUY_SPREAD: parseFloat(pairObj.SPREAD_BUY),
                SELL_SPREAD: parseFloat(pairObj.SPREAD_SELL),
                priceDecimal: pairObj.PRICE_PRECISION,
                volumeDecimal: pairObj.VOLUME_PRECISION,
            });
        } else {
            setBookSell([]);
            setBookBuy([]);
            setShowLoaderBookSell(false);
            setShowLoaderBookBuy(false);
        }
    };

    return (
        <Layout>
            <div className="common_bg_style bg-position pb-0">
                <div className="container">
                    <div className="row">
                        <div className={styles.head_section}>
                            <div className="title_heading d-flex p-0">
                                <p
                                    onClick={() => {
                                        navigate(`/trading/advance/${selectedFirstCoin}_${selectedLastCoin}`);
                                        localStorage.setItem("FirstCoin", selectedFirstCoin.toUpperCase());
                                        localStorage.setItem("BaseCoin", selectedLastCoin.toUpperCase());
                                        localStorage.setItem("RunningPair", selectedFirstCoin.toUpperCase() + selectedLastCoin.toUpperCase());
                                    }}
                                >
                                    Trading
                                </p>
                                <h4>Full Order Book</h4>
                            </div>
                            {firstCoins.length > 0 && lastCoins.length > 0 && (
                                <div className={styles.order_coin_head}>
                                    <div>
                                        <SelectField
                                            value={firstCoins.find((coin) => coin === selectedFirstCoin) ? { value: selectedFirstCoin, label: selectedFirstCoin } : null}
                                            optionSData={firstCoins.map((coin) => ({
                                                value: coin,
                                                label: coin,
                                            }))}
                                            placeholder="coin"
                                            onChangeData={(selectedOption) => {
                                                setShowLoaderBookBuy(true);
                                                setShowLoaderBookSell(true);
                                                setSelectedFirstCoin(selectedOption?.value);
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <SelectField
                                            value={lastCoins.find((coin) => coin === selectedLastCoin) ? { value: selectedLastCoin, label: selectedLastCoin } : null}
                                            optionSData={lastCoins.map((coin) => ({
                                                value: coin,
                                                label: coin,
                                            }))}
                                            placeholder="coin"
                                            onChangeData={(selectedOption) => {
                                                setShowLoaderBookBuy(true);
                                                setShowLoaderBookSell(true);
                                                setSelectedLastCoin(selectedOption?.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={`${styles.table_section} row`}>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className={styles.coin_list_left}>
                                <div className={styles.table_head}>
                                    <ul>
                                        <li>Amount ({selectedFirstCoin})</li>
                                        <li>Price ({selectedLastCoin})</li>
                                        <li>Total ({selectedFirstCoin})</li>
                                    </ul>
                                </div>
                                <div className={`${styles.table_body} position-relative`}>
                                    <ul>
                                        {showLoaderBookBuy ? (
                                            <div className={styles.loader_order}>
                                                <Loader />
                                            </div>
                                        ) : bookBuy.length > 0 ? (
                                            bookBuy.map((buy, i) => (
                                                <li
                                                    key={i}
                                                    className={styles.volume_chart}
                                                    style={{
                                                        "--buy-sell": "rgba(33 ,183 ,168 , 0.3)",
                                                        "--amount": buy.volume,
                                                        "--overall-amount": totalBuyVolume,
                                                        borderTopColor: "transparent",
                                                    }}
                                                >
                                                    <p>{parseFloatAmt(buy.volume, volumeDecimal)}</p>
                                                    <p className="green_color">{parseFloatAmt(buy.price, priceDecimal)}</p>
                                                    <p>{buy.totalBase}</p>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="d-block">
                                                <div className={`${styles.empty_record} ${styles.empty_record_exchange}`}>
                                                    <img src={emptyRecordImg} alt="" />
                                                    <span>No data found</span>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className={styles.coin_list_right}>
                                <div className={styles.table_head}>
                                    <ul>
                                        <li>Amount ({selectedFirstCoin})</li>
                                        <li>Price ({selectedLastCoin})</li>
                                        <li>Total ({selectedFirstCoin})</li>
                                    </ul>
                                </div>
                                <div className={`${styles.table_body} ${styles.table_body_right}`}>
                                    <ul>
                                        {console.log(bookSell, "bookSell")}
                                        {showLoaderBookSell ? (
                                            <div className={styles.loader_order}>
                                                <Loader />
                                            </div>
                                        ) : bookSell.length > 0 ? (
                                            bookSell.map((sell, i) => (
                                                <li
                                                    key={i}
                                                    className={styles.volume_chart}
                                                    style={{
                                                        "--buy-sell": "rgba(239, 89, 84, 0.15)",
                                                        "--amount": sell.volume,
                                                        "--overall-amount": totalSellVolume,
                                                        borderTopColor: "transparent",
                                                    }}
                                                >
                                                    <p>{parseFloatAmt(sell.volume, volumeDecimal)}</p>
                                                    <p className="red_color">{parseFloatAmt(sell.price, priceDecimal)}</p>
                                                    <p>{sell.totalBase}</p>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="d-block">
                                                <div className={`${styles.empty_record} ${styles.empty_record_exchange}`}>
                                                    <img src={emptyRecordImg} alt="" />
                                                    <span>No data found</span>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
